export const getPropertyValue = (document, property) => {
    if (typeof window === 'undefined') {
        return;
    }
    return window
        .getComputedStyle(document.documentElement)
        .getPropertyValue(property);
};
export const setPropertyValue = (document, property, value) => {
    document.documentElement.style.setProperty(property, value);
};
//# sourceMappingURL=css-utils.js.map